"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yearDiagnosedSelect = exports.ongoingRadio = exports.diagnosedCheckbox = exports.detailsTextarea = exports.conditionConfig = exports.ConditionDefinition = void 0;

var _range = require("../../../utils/range");

var _fieldDefinitionTypes = require("../../../fields/config/fieldDefinitionTypes");

var _types = require("../../../types");

var _index = require("../../config/index");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var ComponentConfigDefinition = _flowRuntime["default"].tdz(function () {
  return _index.ComponentConfigDefinition;
});

var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.ComponentElementDefinition;
});

var TextareaDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.TextareaDefinition;
});

var SelectDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.SelectDefinition;
});

var RadioDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.RadioDefinition;
});

var CheckboxDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.CheckboxDefinition;
});

var detailsTextarea = {
  key: 'details',
  type: 'textarea',
  label: 'Details of treatments and investigations',
  ui: {
    classes: 'col span_12_of_12'
  },
  validation: []
};
exports.detailsTextarea = detailsTextarea;
var ongoingRadio = {
  key: 'ongoing',
  label: 'Condition Ongoing',
  type: 'radio',
  normalize: 'boolean',
  items: [{
    key: 'yes',
    label: 'Yes',
    value: 'true'
  }, {
    key: 'no',
    label: 'No',
    value: 'false'
  }],
  ui: {
    classes: 'large'
  },
  validation: []
};
exports.ongoingRadio = ongoingRadio;

var ConditionDefinition = _flowRuntime["default"].type("ConditionDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(ComponentElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("condition")))));

exports.ConditionDefinition = ConditionDefinition;

var diagnosedCheckbox = function diagnosedCheckbox(condition) {
  return {
    key: "diagnosed",
    type: 'checkbox',
    normalize: 'checkbox',
    id: condition.key,
    items: [{
      key: condition.key,
      label: condition.label || condition.key
    }],
    ui: {
      classes: 'small'
    },
    validation: []
  };
};

exports.diagnosedCheckbox = diagnosedCheckbox;
var yearDiagnosedSelect = {
  key: 'yearDiagnosed',
  label: 'Year Diagnosed',
  type: 'select',
  items: (0, _range.yearRange)(0, -31),
  validation: [],
  ui: {
    classes: 'col span_5_of_12'
  }
};
exports.yearDiagnosedSelect = yearDiagnosedSelect;
var conditionConfig = {
  type: 'condition',
  // $FlowFixMe - type and key are missing in object literal
  fields: [detailsTextarea, ongoingRadio, yearDiagnosedSelect, diagnosedCheckbox],
  validation: [{
    conditionRequired: true
  }]
};
exports.conditionConfig = conditionConfig;